//#region src/maitred_activity_scope.ts
var MaitredActivityScope = /* @__PURE__ */ function(MaitredActivityScope) {
	MaitredActivityScope["Bite"] = "bite";
	MaitredActivityScope["Org"] = "org";
	MaitredActivityScope["Site"] = "site";
	MaitredActivityScope["Location"] = "location";
	return MaitredActivityScope;
}(MaitredActivityScope || {});
//#endregion
export { MaitredActivityScope };

//# sourceMappingURL=maitred_activity_scope.js.map